<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div v-if="!formData.hasOwnProperty('id')" class="row items-center">
      <div class="col-12 q-px-sm">
        <assignOrganization
          :id="organizations_id"
          @changed="(val) => (organizations_id = val)"
        />
      </div>
      <div class="col-12 q-px-sm">
        <assignDevice
          :id="device"
          :disable="!organizations_id"
          label="Assign Initial Device"
          :emitValue="false"
          allowOwned
          :filterOrganizationsID="organizations_id"
          @changed="(val) => (device = val)"
        />
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Deployment Name"
          counter
        ></q-input>
      </div>
    </div>
    <div
      v-if="formData.hasOwnProperty('id')"
      class="row items-center deploymentForm"
    >
      <div class="col-12 q-mb-sm">
        <q-btn
          v-if="
            ['superAdmin', 'appAdmin', 'orgAdmin'].includes(
              currentUserData.role
            )
          "
          :color="addUserButtonColors.backgroundColor"
          unelevated
          :text-color="addUserButtonColors.textColor"
          no-caps
          class="q-mr-sm"
          @click="togglAddUser"
        >
          <q-icon size="xs" name="mdi-account-plus" class="q-mr-sm"></q-icon>
          Add User
        </q-btn>
        <q-btn
          v-if="!formData.end_ts"
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          :loading="endDeploymentLoading"
          @click="endDeployment"
        >
          <q-icon size="xs" name="mdi-cancel" class="q-mr-sm"></q-icon>
          End Deployment
        </q-btn>
      </div>
      <div v-if="view == 'deploymentDetails'" class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Deployment Name</h6>
            <p>{{ formData.name }}</p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Deployment Status</h6>
            <p :class="`text-${formData.end_ts ? 'negative' : 'positive'}`">
              {{ formData.end_ts ? "Finished" : "Active" }}
            </p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Deployment Start</h6>
            <p>{{ formData.start_ts }}</p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Deployment End</h6>
            <p>{{ formData.end_ts }}</p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Applications Name</h6>
            <p>{{ formData.applications_name }}</p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Organizations Name</h6>
            <p>{{ formData.organizations_name }}</p>
          </div>
          <div class="col-12 col-sm-6 q-px-sm">
            <h6 class="q-my-none">Events Count</h6>
            <p>{{ formData.eventsCount }}</p>
          </div>

          <!--          <div class="col-12">-->
          <!--            <q-btn-->
          <!--              @click="save()"-->
          <!--              :loading="saveLoading"-->
          <!--              color="primary"-->
          <!--              no-caps-->
          <!--              class="float-right"-->
          <!--            >-->
          <!--              <q-icon-->
          <!--                name="mdi-content-save"-->
          <!--                color="white"-->
          <!--                class="q-mr-sm"-->
          <!--                size="xs"-->
          <!--              ></q-icon>-->
          <!--              Save-->
          <!--            </q-btn>-->
          <!--          </div>-->
          <template id="DevicesBlock">
            <div class="col-12">
              <h6 class="q-my-none">Devices</h6>
            </div>
            <div class="col-12" v-if="!deploymentDevicesLoading && !formData.end_ts">
              <div class="row">
                <div class="col-grow">
                  <assignDevice
                    ref="newDeviceAssign"
                    :id="newDevice"
                    :disable="!formData.organizations_id"
                    label="Assign Additional Device"
                    :emitValue="false"
                    allowOwned
                    :filterOrganizationsID="formData.organizations_id"
                    @changed="(val) => (newDevice = val)"
                  />
                </div>
                <div class="col-shrink" v-if="newDevice">
                  <q-btn round size="small" icon="add" color="blue" class="q-ma-xs" @click="alterDevice(newDevice.id, 'add')" alt="Add Device"></q-btn>
                </div>
              </div>
            </div>
            <div
              v-if="!deploymentDevicesLoading"
              aria-hidden="true"
            >
              <q-chip class="text-center" color="blue" text-color="white"
                      v-for="(device, index) in deploymentDevices"
                      :key="`deploymentDevice_${index}`"
                      removable @remove="alterDevice(device.devices_id, 'remove')"
              >
                {{ device.devices_id }}
              </q-chip>
            </div>
            <div
              class="col-12"
              v-if="deploymentDevices.length < 1 && !deploymentDevicesLoading"
            >
              <p>No Devices</p>
            </div>
            <div class="col-12" v-if="deploymentDevicesLoading">
              <q-skeleton animation="pulse-y"/>
            </div>
          </template>
          <template id="usersBlock">
            <div class="col-12">
              <h6 class="q-my-none">Users</h6>
            </div>
            <div
              v-if="!deploymentUsersLoading"
              class="col-12"
              v-for="(user, index) in deploymentUsers"
              :key="`deploymentUser_${index}`"
            >
              <p>{{ user.name }} <{{ user.email }}></p>
            </div>
            <div
              class="col-12"
              v-if="deploymentUsers.length < 1 && !deploymentUsersLoading"
            >
              <p>No Users</p>
            </div>
            <div class="col-12" v-if="deploymentUsersLoading">
              <q-skeleton animation="pulse-y"/>
            </div>
          </template>
        </div>
      </div>
      <div v-if="view == 'addUserForm'" class="col-12">
        <div class="row">
          <div class="col-11 q-px-sm">
            <assignUser
              :id="formData.users_id"
              @changed="(val) => (addUserFormData.users_id = val)"
            />
          </div>
          <div class="col-1">
            <q-btn
              color="accent"
              no-caps
              flat
              round
              class="q-mr-sm"
              style="margin-top: 10px"
              @click="addUser"
              :loading="addUserLoading"
            >
              <q-icon size="sm" name="mdi-plus"></q-icon>
            </q-btn>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import {mapGetters} from "vuex";
import assignOrganization from "@/components/organizations/assignOrganization.vue";
import assignDevice from "@/components/devices/assignDevice.vue";
import assignUser from "@/components/users/assignUser.vue";

export default {
  components: {assignOrganization, assignDevice, assignUser},
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      deploymentUsers: "deployments/users",
      deploymentDevices: "deployments/devices",
      deploymentUsersLoading: "deployments/usersLoading",
      deploymentDevicesLoading: "deployments/devicesLoading",
    }),
    addUserButtonColors: function () {
      let data = {};

      if (this.view == "addUserForm") {
        data = {
          backgroundColor: "accent",
          textColor: "secondary",
        };
      } else {
        data = {
          backgroundColor: "secondary",
          textColor: "accent",
        };
      }

      return data;
    },
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
  data: () => ({
    // Extra Data
    organizations_id: null,
    view: "deploymentDetails",
    device: null,
    newDevice: null,
    formData: {
      ownership_id: null,
    },
    addUserFormData: {
      users_id: null,
    },
    addUserLoading: false,
    endDeploymentLoading: false,
    saveLoading: false,
  }),
  beforeCreate() {
    this.$store.dispatch("organizations/loadAll");
    this.$store.dispatch("devices/loadAll");
    this.$store.dispatch("users/loadAll");
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        if (this.formData.id) {
          this.$store.dispatch("deployments/loadDeploymentUsers", this.formData.id);
          this.$store.dispatch("deployments/loadDeploymentDevices", this.formData.id);
        }
      } else {
        this.formData = {
          ownership_id: null,
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.formData.ownership_id = this.device.ownerships_id;
            this.formData.device = {
              id: this.device.id
            };
            this.$store
              .dispatch("deployments/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    togglAddUser() {
      this.view =
        this.view == "addUserForm" ? "deploymentDetails" : "addUserForm";
    },

    save() {
      this.saveLoading = true;
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store
          .dispatch("deployments/save", this.formData)
          .then((result) => {
            this.saveLoading = false;
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
      });
    },
    addUser() {
      this.addUserLoading = true;
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.addUserFormData.deployments_id = this.formData.id;
          this.$store
            .dispatch(
              "deployments/grantUserDeploymentAccess",
              this.addUserFormData
            )
            .then((result) => {
              this.addUserLoading = false;
              if (result.Result == "Success") {
                this.userEmail = "";
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        } else {
          this.addUserLoading = false;
        }
      });
    },
    alterDevice(devices_id, action) {
      if (this.deploymentDevices.length <= 1 && action == 'remove') {
        this.$q.dialog(
          {
            title: 'Cannot remove last device',
            message: 'Each deployment is required to have at least one device attached to it. Please add a new device before removing this one.',
            ok: {label: 'Ok', color: 'blue'},
            persistent: true
          }
        );
        return;
      }
      let assignComponent = this.$refs.newDeviceAssign;
      this.$store
        .dispatch("deployments/alterDeploymentDevice", {devices_id, action, deployments_id: this.formData.id})
        .then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.newDevice = null;
            this.$store.dispatch("devices/loadAll");
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: result.Response.Message,
            });
          }
        });
    },
    endDeployment() {
      this.$q.dialog({
        title: 'Confirm',
        message: 'Are you sure?',
        cancel: {label: 'No', color: 'blue'},
        ok: {label: 'Yes', color: 'red', flat: true},
        persistent: true
      }).onOk(() => {
        this.endDeploymentLoading = true;
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("deployments/endDeployment", {id: this.formData.id})
              .then((result) => {
                this.endDeploymentLoading = false;
                if (result.Result == "Success") {
                  this.userEmail = "";
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.endDeploymentLoading = false;
          }
        });
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.deploymentForm {
  h6 {
    color: $accent;
    font-size: 12pt;
    font-weight: bold;
  }
}
</style>
